module.exports = __webpack_public_path__ + "img/6.e59c4ba4.jpg";